import {
    initTracerError,
    initTracerLog,
    initTracerPerformance,
    initTracerWebVitals
    // @ts-ignore: из-за ?inline, чтобы сборщик не склеил эти импорты с импортами в TracerService.ts, который конвертится в amd
} from '@apptracer/sdk?inline';

type TracerValue = string | number | boolean;

interface ITracerError extends Error {
    skipFilter?: boolean;
    isNonFatal?: boolean;
    getIsNonFatal?: () => boolean;
}

const OK = window.OK || (window.OK = {});

// Инициализируем модуль для накопления логов
const logModule = initTracerLog();

/** При возвращаемом значении false - ошибка фильтруется, если true - не фильтруется */
function shouldFilterError(err: ITracerError) {
    if (err?.skipFilter) {
        return true;
    }

    if (checkIfErrConvertedToNonFatalManually(err)) {
        return false;
    }

    if (err?.isNonFatal || err?.getIsNonFatal?.()) {
        return false;
    }

    return !checkIfErrStackMatchErrsList(err, OK.Tracer.ignoreErrors);
}

function addMetricAttributes() {
    const url = window.location.pathname;

    if (OK.state) {
        return {
            url: url,
            state: OK.state.getCurrentStateId()
        };
    }

    return {
        url: url
    };
}

function checkIfErrStackMatchErrsList(err: ITracerError, errList: string[]) {
    if (!errList || !err) {
        return false;
    }

    return errList.some((e) => {
        return err.stack?.includes(e) || err.message?.includes(e);
    });
}

function checkIfErrConvertedToNonFatalManually(err: ITracerError) {
    if (checkIfErrStackMatchErrsList(err, OK.Tracer.nonFatalErrors)) {
        /** Необходимо, чтобы отправленная NON_FATAL ошибка снова не отфильтровалась */
        err.skipFilter = true;
        /** Логируем отфильтрованные CRASH ошибки из OK.Tracer.nonFatalErrors ошибки как NON_FATAL */
        OK.Tracer.error(err);
        return true;
    }

    return false;
}

// Инициализация модуля для сбора ошибок
const errorModule = initTracerError({ filterError: shouldFilterError });

// Инициализация модуля для сбора метрик перфоманса
initTracerPerformance();

// Собираем Web Vitals метрики в TracerPerformance
initTracerWebVitals({ addMetricAttributes });

/**
 * Трейсер автоматически подписывается на ивенты "error" и "unhandledrejection", поэтому дополнительно логировать ошибки в него нет необходимости.
 * Логируем только в Graylog ошибки, которые не фильтруются.
 */
function windowErrorHandler(e: ErrorEvent) {
    OK.logger.saveAsClientError(e);
}

function windowUnhandledRejectionHandler(e: PromiseRejectionEvent) {
    OK.logger.saveAsClientError(e);
}

/**
 * Заполняем необходимые на старте методы. После того как модуль инициализируется, OK.Tracer примет в качестве значения класс TracerService (см. TracerService.ts)
 */
OK.Tracer = {
    log: function (message: string) {
        logModule.log(message);
    },
    error: function (error: ITracerError, keys: TracerValue) {
        errorModule.setErrorKey('currentUrl', window.location.href);
        errorModule.error(error, { keys });
    },
    setErrorKey: function (key: string, value: TracerValue) {
        errorModule.setErrorKey(key, value);
    },
    removeErrorKey: function (key: string) {
        errorModule.removeErrorKey(key);
    },
    tracerAttached: function (tracer: typeof OK.Tracer) {
        OK.Tracer = tracer;
    }
};

window.addEventListener('error', windowErrorHandler);
window.addEventListener('unhandledrejection', windowUnhandledRejectionHandler);
